import { useCallback, useState } from 'react'
import useDebounceValue from './useDebounceValue'

// Hook untuk handle responsive UI dari redux
const useSuggestion = ({ name, module, onDropdownVisibleCallback, uniqueId }) => {
  const [open, setOpen] = useState(false)
  const [search, setSearch] = useState('')

  const containerId = `suggestion-${module}-${name}${uniqueId ? `-${uniqueId}` : ''}`
  const popUpClassName = `suggestion-${module}-popup-${name}${uniqueId ? `-${uniqueId}` : ''}`

  const debouncedSearch = useDebounceValue(search, 1200)

  const dropdownVisibleChangeHandler = useCallback(
    (value) => {
      if (!value) {
        setSearch('')
      }
      setOpen(value)
      if (typeof onDropdownVisibleCallback === 'function') {
        onDropdownVisibleCallback(value)
      }
    },
    [onDropdownVisibleCallback],
  )

  const getPopupContainer = useCallback(() => document.getElementById(containerId), [containerId])

  const searchHandler = useCallback((v) => setSearch(v), [])

  const popUpScrollHandler = useCallback(
    (e, { hasNextPage, isFetchingNextPage, fetchNextPage }) => {
      const { target } = e
      if (
        hasNextPage &&
        !isFetchingNextPage &&
        Math.ceil(target.scrollTop + target.offsetHeight) === target.scrollHeight
      ) {
        fetchNextPage()
        if (typeof target.scrollTo === 'function') {
          target.scrollTo(0, target.scrollHeight)
        }
      }
    },
    [],
  )

  return {
    open,
    setOpen,
    containerId,
    popUpClassName,
    debouncedSearch,
    onDropdownVisible: dropdownVisibleChangeHandler,
    getPopupContainer,
    onSearch: searchHandler,
    onPopUpScroll: popUpScrollHandler,
    setSearch,
    search,
  }
}

export default useSuggestion
